export default class PersonalDetailModel {
    id: number = 0;
    caseId: number = 0;
    title: string | null = null;
    firstName: string = "";
    lastName: string = "";
    telephone: string = "";
    emailAddress: string = "";
    policyNumber: string = "";
    constructor() { }
}
